window.app = window.app || {};

window.app.podsBanner = {
  wrapper: document.querySelector('.mt-pods-banner__logos'),
  el: document.querySelector('.mt-pods-banner__logos .swiper'),
  items: document.querySelectorAll('.mt-pods-banner__logos-item'),
  video: document.querySelector('.mt-pods-banner__video'),

  init: function() {
    const _this = this;
    if (!_this.el) return;

    const itemsRatio = [..._this.items].map(item => {
      const ratio = parseFloat(item.dataset.ratio);
      return Math.floor(ratio * 100) / 100;
    });
    const itemsSet = new Set(itemsRatio);

    _this.slider = new Swiper(_this.el, {
      slidesPerView: 'auto',
      centeredSlides: true,
      centeredSlidesBounds: true,
      watchSlidesProgress: true,
      spaceBetween: 16,
      slidesOffsetBefore: 30,
      slidesOffsetAfter: 30,
      speed: (itemsSet.size > 1) ? 4500 : 2500,
      loop: true,
      forceLoop: true,
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
        pauseOnMouseEnter: false	
      },
      breakpoints: {
        768: {
          centeredSlides: false,
          spaceBetween: 64
        }
      }
    });

    // Fix for mobile
    const carouselIntersection = (entries, observer) => entries.forEach(entry => entry.isIntersecting && _this.slider.autoplay.start());
    const carouselObserver = new IntersectionObserver(carouselIntersection, { root: null, rootMargin: '0px', threshold: 0.1 });
    carouselObserver.observe(_this.el);
    setTimeout(() => _this.slider.autoplay.start(), 1000);

    // Video
    if (_this.video && _this.video.dataset.vidDesktop != '' && _this.video.dataset.vidMobile != '') {
      const config = {
        breakpoint: 768,
        currentState: 'desktop'
      };
      const updateVideoSrc = () => {
        let videoSrc = _this.video.src;

        if (window.innerWidth >= config.breakpoint && config.currentState == 'mobile') {
          videoSrc = _this.video.dataset.vidDesktop;
        } else if (window.innerWidth < config.breakpoint && config.currentState == 'desktop') {
          videoSrc = _this.video.dataset.vidMobile;
        }
        
        if (videoSrc == _this.video.src) return;
        config.currentState = (window.innerWidth >= config.breakpoint) ? 'desktop' : 'mobile';
        _this.video.src = videoSrc;
        _this.video.load();
        _this.video.play();
      }
      updateVideoSrc();
      window.addEventListener('resize', () => updateVideoSrc());
      document.addEventListener('touchstart', () => !_this.video.playing && _this.video.play(), { once: true });
    }
  }
}
window.app.podsBanner.init();